import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/',
      component: resolve => require(['../components/layout/Layout.vue'], resolve),
      meta: { title: '' },
      children:[
        {
          path: '/index',
          component: resolve => require(['../components/pages/Index.vue'], resolve),
          meta: { title: '首页' }
        },
        {
          path: '/user',
          component: resolve => require(['../components/pages/User.vue'], resolve),
          meta: { title: '账号管理' }
        },
        {
          path: '/shop',
          component: resolve => require(['../components/pages/Shop.vue'], resolve),
          meta: { title: '商户管理' }
        },
        {
          path: '/officer',
          component: resolve => require(['../components/pages/Officer.vue'], resolve),
          meta: { title: '执法人员' }
        },
        {
          path: '/worker',
          component: resolve => require(['../components/pages/Worker.vue'], resolve),
          meta: { title: '维护人员' }
        },
        {
          path: '/area',
          component: resolve => require(['../components/pages/Area.vue'], resolve),
          meta: { title: '区域管理' }
        },
        {
          path: '/data',
          component: resolve => require(['../components/pages/Data.vue'], resolve),
          meta: { title: '监控数据' }
        },
        {
          path: '/device/history',
          name: 'DeviceHistory',
          component: resolve => require(['../components/pages/DeviceHistory.vue'], resolve),
          meta: { title: '设备清洗记录' }
        },
        {
          path: '/shop/record',
          name: 'ShopRecord',
          component: resolve => require(['../components/pages/ShopRecord.vue'], resolve),
          meta: { title: '上报记录' }
        },
      ]
    },
    {
      path: '/login',
      component: resolve => require(['../components/pages/Login.vue'], resolve)
    },
    {
      path: '*',
      component: resolve => require(['../components/pages/Index.vue'], resolve),
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js